import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';
import { GenericSelect } from '../../components';


const LossEntryCalculationMethodInput: InputWithSource = ({ input }) => (
    <GenericSelect label={input.name} input={input} />
);

LossEntryCalculationMethodInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(LossEntryCalculationMethodInput);
